module.exports = __webpack_public_path__ + "img/arrow-circle-right.efab156c.png";